import React from 'react';
import { Grid, Typography, Link, IconButton, Tooltip, Menu } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import MediaItemsSearch from '../common/MediaItemsSearch';
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';

const styles = theme => ({
    stockImagesLabel: {
        marginRight: theme.spacing(1)
    },
    orientationSettings: {
        marginRight: '5px'
    }
});

const StockImagesSearch = (props) => {
    const { classes, searchValue, isSearching, onSearchValueChange, contextMenuAnchor, setContextMenuAnchor, onSearchValueSubmit, clearResults, disableClearButton, stockImageOrientationSelect } = props;
  
    return (
        <>
            <Grid>
                <Typography
                    className={classes.stockImagesLabel}
                    variant='subtitle2'
                    color='textSecondary'
                >
                    Photos by&nbsp;
                    <Link
                        href='https://www.pexels.com'
                        target='_blank'
                        color='textSecondary'
                        underline='always'
                    >
                        Pexels
                    </Link>
                </Typography>
            </Grid>
            <Grid>
                <Tooltip
                    title={"Orientation Filter"}
                    placement={'top'}
                    arrow
                >
                    <IconButton
                        className={classes.orientationSettings}
                        onClick={(event) => setContextMenuAnchor(event.currentTarget)}
                        aria-label='Orientation Settings'
                        aria-controls='orientation-settings-menu'
                        aria-haspopup='true'
                        size="large">
                        <FilterListIcon />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid>
                <Tooltip
                    title={"Clear Results"}
                    placement={'top'}
                    arrow
                >
                    <span>
                        <IconButton
                            className={classes.orientationSettings}
                            onClick={clearResults}
                            disabled={disableClearButton}
                            aria-label='Orientation Settings'
                            aria-controls='orientation-settings-menu'
                            aria-haspopup='true'
                            size="large">
                            <CloseIcon />
                        </IconButton>
                    </span>
                </Tooltip>
            </Grid>
            <Grid>
                <MediaItemsSearch
                    value={searchValue}
                    placeholder="Search Images"
                    onValueChange={onSearchValueChange}
                    onValueSubmit={onSearchValueSubmit}
                    isSearching={isSearching}
                />
            </Grid>
            <Menu
                id='orientation-settings-menu'
                anchorEl={contextMenuAnchor}
                keepMounted
                open={Boolean(contextMenuAnchor)}
                onClose={() => setContextMenuAnchor(undefined)}
            >
                {stockImageOrientationSelect}
            </Menu>
        </>
    );
};

export default withStyles(StockImagesSearch, styles);